import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { setPatientInformation } from '../../store/slices/metaDataSlice';
import { ToggleButtons } from '../../shared/components/toggleButtons';

export const PatientType = () => {
  const { patientInformation } = useAppSelector(metaDataSelector);
  const dispatch = useDispatch();

  return (
    <>
      <ToggleButtons
        name1={'ADULT'}
        name2={'PAEDIATRIC'}
        selection={patientInformation?.type}
        handleToggle={(val: any) =>
          dispatch(
            setPatientInformation({
              ...patientInformation,
              type: val.currentTarget.value
            })
          )
        }
      />
      <ToggleButtons
        name1={'MALE'}
        name2={'FEMALE'}
        selection={patientInformation?.gender}
        handleToggle={(val: any) =>
          dispatch(
            setPatientInformation({
              ...patientInformation,
              gender: val.currentTarget.value
            })
          )
        }
      />
    </>
  );
};
